module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n3n4n8n-9c8f01a5bab89b5fbaba5b4b304fde02.svg";